import { useContext, useEffect, useRef, useState } from 'react'
import Btn_loader from '../Btn_loader'
import { MyContext } from '../../Context/MyProvider';
import { useLocation, useNavigate } from 'react-router-dom';
import KundaliMatching from "../../image/KundaliMatching.png";
import ImageLoad from '../ImageLoad';
import PageLoading from '../PageLoading';
import { AnimatePresence, motion } from 'framer-motion';
import ThumbUp from "../../image/thumbsup.png";
import ThumbDown from "../../image/thumbsdown.png";
import { useTranslation } from 'react-i18next';

const renderVal = (val) => {
    if (val === null || val === undefined) return "";
    if (typeof val === 'object') {
        return val.result || val.name || JSON.stringify(val);
    }
    return val;
};

const Kundali_Matching_details = () => {

    const { t } = useTranslation();
    const { HandleCallApi, setIsToast, setToastMsg } = useContext(MyContext);

    const [loading, setLoading] = useState(true);
    const [isstep, setIsStep] = useState(0);
    const [detailsstep, setDetailsStep] = useState(1);
    const [showlist, setShowList] = useState(false);
    const [apiloading, setApiLoading] = useState("");
    const [userdata, setUserData] = useState("");

    const Location = useLocation();
    const navigate = useNavigate();
    const HomeRef = useRef(false);

    const kundliTypeList = ["Introduction", "Basic Astrological Details", "Planetary Positions", "Horoscope Charts", `Vimshottari Dasha P1`, `Vimshottari Dasha P2`, "Manglik Analysis", "AshtaKoot", "Bhakut Dosha", "Nadi Dosha", "Ashtakoot Analysis", "DashaKoot", "Personality Report", "Match Making Report", "Nav Pancham Yoga"];
    const KundliTypeApiList = ["introduction", "basicAstrologicalDetails", "planetaryPositions", "horoscopeCharts", "vimshottariDashaP1", "vimshottariDashaP2", "manglikAnalysis", "ashtakoot", "bhakutDosha", "nadiDosha", "ashtakootAnalysis", "dashakoot", "personalityReport", "matchMakingReport", "navPanchamYoga"];

    useEffect(() => {   
        if (!Location.state) {
            setToastMsg("Please enter matching details first!");
            setIsToast(true);
            navigate("/kundli-matching");
            return;
        }
        handleFetchData(isstep);
    }, []);

    useEffect(() => {
        const activeEl = document.getElementById(`tab-${isstep}`);
        if (activeEl) {
            activeEl.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
    }, [isstep]);

    const handleFetchData = async (index) => {

        if (HomeRef.current) return;
        HomeRef.current = true;

        const ApiBody = {
            ...Location.state,
            section: KundliTypeApiList[index]
        }

        const Response = await HandleCallApi("Post", "user/kundli-matching", ApiBody);
        if (Response && Response.data) {
            if (Response.data.Result === false) {
                setToastMsg(Response.data.message || "Sorry This Plan is currntly closed");
                setIsToast(true);
                navigate("/kundli-matching");
                return;
            }
            setUserData(Response.data);
            setIsStep(index);
            setDetailsStep(index + 1);
            setShowList(false);
        } else {
            setToastMsg("Could not fetch matching details. Please try again.");
            setIsToast(true);
            navigate("/kundli-matching");
            return;
        }
        setApiLoading("");
        setLoading(false);
    }

    const handleTypeOfdetail = (count, title) => {
        HomeRef.current = false;
        setApiLoading(title);
        handleFetchData(count);
    }

    const handlecCapitalizeWords = (word = "") => word.toLowerCase().split(" ").map(item => item.charAt(0).toUpperCase() + item.slice(1)).join(",");

    return (
        <div className="kundli_detail">

            {!loading && <div className="width_container">

                <div className='hidden max-_768_:block'>
                    <div className="flex items-center justify-center">
                        <div className="w-full flex items-center border px-[20px] py-[15px] rounded-[15px] bg-white">
                            <button disabled={isstep === 0 || apiloading} onClick={() => handleTypeOfdetail(isstep - 1, "Type")} className="bg-[--bgcolor] p-[8px] rounded-full">
                                <svg width="17" height="17" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M21.7501 12C21.7501 12.414 21.4141 12.75 21.0001 12.75H4.81115L10.5311 18.47C10.8241 18.763 10.8241 19.238 10.5311 19.531C10.3851 19.677 10.1931 19.751 10.0011 19.751C9.80909 19.751 9.61706 19.678 9.47106 19.531L2.47106 12.531C2.40206 12.462 2.3472 12.3791 2.3092 12.2871C2.2332 12.1041 2.2332 11.8971 2.3092 11.7141C2.3472 11.6221 2.40206 11.539 2.47106 11.47L9.47106 4.46999C9.76406 4.17699 10.2391 4.17699 10.5321 4.46999C10.8251 4.76299 10.8251 5.23803 10.5321 5.53103L4.81213 11.251H21.0001C21.4141 11.25 21.7501 11.586 21.7501 12Z" fill="white" />
                                </svg>
                            </button>
                            <div className="w-full">
                                <h1 onClick={() => apiloading !== "Type" && setShowList(true)} className={`text-center font-medium text-[17px] ${apiloading !== "Type" ? "cursor-pointer" : "cursor-auto"}`}>
                                    {apiloading === "Type"
                                        ? <Btn_loader CustomeStyle={"bg-[--bgcolor]"} />
                                        : t(kundliTypeList[isstep])}
                                </h1>
                            </div>
                            <button disabled={isstep === (kundliTypeList.length - 1) || apiloading} onClick={() => handleTypeOfdetail(isstep + 1, "Type")} className="bg-[--bgcolor] p-[8px] rounded-full">
                                <svg width="17" height="17" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M21.6919 12.2871C21.6539 12.3791 21.599 12.462 21.53 12.531L14.53 19.531C14.384 19.677 14.192 19.751 14 19.751C13.808 19.751 13.616 19.678 13.47 19.531C13.177 19.238 13.177 18.763 13.47 18.47L19.1899 12.75H3C2.586 12.75 2.25 12.414 2.25 12C2.25 11.586 2.586 11.25 3 11.25H19.189L13.469 5.53005C13.176 5.23705 13.176 4.76202 13.469 4.46902C13.762 4.17602 14.237 4.17602 14.53 4.46902L21.53 11.469C21.599 11.538 21.6539 11.6209 21.6919 11.7129C21.7679 11.8969 21.7679 12.1031 21.6919 12.2871Z" fill="white" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>

                <div className="relative w-full flex items-center group mt-4">
                    <button 
                        onClick={() => {
                            const container = document.getElementById('category-container');
                            if (container) container.scrollBy({ left: -200, behavior: 'smooth' });
                        }}
                        className="absolute left-[-15px] z-10 bg-white hover:bg-orange-50 border border-orange-100 shadow-md hover:shadow-lg rounded-full p-2 transition-all duration-300 hover:scale-105 active:scale-95 hidden _768_:flex items-center justify-center text-orange-500 hover:text-orange-600"
                    >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15 19L8 12L15 5" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </button>

                    <div id="category-container" className="category w-full">
                        {kundliTypeList.map((item, index) => {
                            const IsSelected = index === isstep;
                            return <div key={index} id={`tab-${index}`} onClick={() => handleTypeOfdetail(index, index)} className={`swiper-slide ${IsSelected ? "select" : ""}`}>
                                {apiloading === index
                                    ? <Btn_loader CustomeStyle={"bg-[--bgcolor]"} />
                                    : t(item)}
                            </div>
                        })}
                    </div>

                    <button 
                        onClick={() => {
                            const container = document.getElementById('category-container');
                            if (container) container.scrollBy({ left: 200, behavior: 'smooth' });
                        }}
                        className="absolute right-[-15px] z-10 bg-white hover:bg-orange-50 border border-orange-100 shadow-md hover:shadow-lg rounded-full p-2 transition-all duration-300 hover:scale-105 active:scale-95 hidden _768_:flex items-center justify-center text-orange-500 hover:text-orange-600"
                    >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9 5L16 12L9 19" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </button>
                </div>

                <div className="w-full mt-4 mb-8">

                    {detailsstep === 1 && <div className="flex flex-col items-center justify-center w-full max-w-4xl mx-auto py-8">
                        <ImageLoad url={KundaliMatching} alt={"Kundli img"} CustomeStyle={"w-[280px] hover:scale-105 transition-transform duration-500 mx-auto"} />

                        <div className="flex flex-col md:flex-row items-stretch justify-center gap-8 mt-10 w-full px-4">
                            
                            <div className="flex-1 border border-orange-100/50 rounded-2xl bg-white shadow-sm p-6 hover:shadow-md transition-all duration-300 flex flex-col justify-between items-center text-center">
                                <div className="w-12 h-12 bg-orange-50 rounded-full flex items-center justify-center text-orange-500 mb-4 font-bold text-lg">P1</div>
                                <div>
                                    <h2 className="font-bold text-[22px] text-gray-900 mb-2">{userdata?.data1?.p1?.full_name}</h2>
                                    <span className="inline-block text-xs font-semibold text-orange-500 bg-orange-50 px-3 py-1 rounded-full border border-orange-100/50 mb-3">
                                        {userdata?.data1?.p1?.year}-{userdata?.data1?.p1?.month}-{userdata?.data1?.p1?.day}
                                    </span>
                                    <p className="text-gray-600 text-[14px] flex items-center justify-center gap-1 font-medium">
                                        <svg className="w-4 h-4 text-orange-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                        </svg>
                                        {userdata?.data1?.p1?.place}
                                    </p>
                                </div>
                            </div>

                            <div className="flex items-center justify-center">
                                <div className="w-12 h-12 bg-gradient-to-tr from-orange-500 to-amber-500 text-white font-bold rounded-full shadow-md flex items-center justify-center relative z-10 select-none transform hover:scale-110 transition-transform duration-300">
                                    VS
                                </div>
                            </div>

                            <div className="flex-1 border border-orange-100/50 rounded-2xl bg-white shadow-sm p-6 hover:shadow-md transition-all duration-300 flex flex-col justify-between items-center text-center">
                                <div className="w-12 h-12 bg-orange-50 rounded-full flex items-center justify-center text-orange-500 mb-4 font-bold text-lg">P2</div>
                                <div>
                                    <h2 className="font-bold text-[22px] text-gray-900 mb-2">{userdata?.data1?.p2?.full_name}</h2>
                                    <span className="inline-block text-xs font-semibold text-orange-500 bg-orange-50 px-3 py-1 rounded-full border border-orange-100/50 mb-3">
                                        {userdata?.data1?.p2?.year}-{userdata?.data1?.p2?.month}-{userdata?.data1?.p2?.day}
                                    </span>
                                    <p className="text-gray-600 text-[14px] flex items-center justify-center gap-1 font-medium">
                                        <svg className="w-4 h-4 text-orange-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                        </svg>
                                        {userdata?.data1?.p2?.place}
                                    </p>
                                </div>
                            </div>

                        </div>
                    </div>}

                    {detailsstep === 2 && <div className="w-full flex flex-col lg:flex-row gap-6 my-4 animate_fade_in_card">
                        
                        <div className="flex-1 border border-orange-100/50 rounded-2xl bg-white shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden">
                            <h2 className="px-5 py-4 font-bold text-[18px] text-gray-900 border-b border-gray-100 flex items-center gap-2">
                                <div className="w-2 h-6 bg-gradient-to-b from-orange-500 to-amber-500 rounded-full"></div>
                                {t("Basic Details")}
                            </h2>
                            <div className="p-2 overflow-x-auto">
                                <table className="w-full text-center border-collapse table-fixed min-w-[400px]">
                                    <thead>
                                        <tr className="border-b border-gray-100 bg-orange-50/30">
                                            <th className="px-4 py-3 text-[14px] font-bold text-gray-800 w-[38%] truncate">{userdata?.p1_name}</th>
                                            <th className="px-4 py-3 text-[14px] font-bold text-orange-500 w-[24%] truncate">{t("Parameter")}</th>
                                            <th className="px-4 py-3 text-[14px] font-bold text-gray-800 w-[38%] truncate">{userdata?.p2_name}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {[
                                            { p1: userdata?.data1?.p1 ? `${userdata.data1.p1.year}-${userdata.data1.p1.month}-${userdata.data1.p1.day}` : "", title: "Date of Birth", p2: userdata?.data1?.p2 ? `${userdata.data1.p2.year}-${userdata.data1.p2.month}-${userdata.data1.p2.day}` : "" },
                                            { p1: userdata?.data1?.p1 ? `${userdata.data1.p1.hour} : ${userdata.data1.p1.minute}` : "", title: "Time of Birth", p2: userdata?.data1?.p2 ? `${userdata.data1.p2.hour} : ${userdata.data1.p2.minute}` : "" },
                                            { p1: userdata?.data1?.p1?.latitude, title: "Latitude", p2: userdata?.data1?.p2?.latitude },
                                            { p1: userdata?.data1?.p1?.longitude, title: "Longitude", p2: userdata?.data1?.p2?.longitude },
                                            { p1: userdata?.data1?.p1?.timezone, title: "Timezone", p2: userdata?.data1?.p2?.timezone },
                                            { p1: userdata?.data1?.p1?.sunrise?.split(" ")[0] || "", title: "Sunrise", p2: userdata?.data1?.p2?.sunrise?.split(" ")[0] || "" },
                                            { p1: userdata?.data1?.p1?.sunset?.split(" ")[0] || "", title: "Sunset", p2: userdata?.data1?.p2?.sunset?.split(" ")[0] || "" }
                                        ].map((item, idx) => (
                                            <tr key={idx} className="border-b border-gray-50 last:border-b-0 hover:bg-orange-50/20 transition-colors">
                                                <td className="px-4 py-3 text-[14px] text-gray-600 truncate">{renderVal(item.p1)}</td>
                                                <td className="px-4 py-3 font-semibold text-[13px] text-gray-700 bg-orange-50/10 border-x border-gray-50 whitespace-nowrap">{t(item.title)}</td>
                                                <td className="px-4 py-3 text-[14px] text-gray-600 truncate">{renderVal(item.p2)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div className="flex-1 border border-orange-100/50 rounded-2xl bg-white shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden">
                            <h2 className="px-5 py-4 font-bold text-[18px] text-gray-900 border-b border-gray-100 flex items-center gap-2">
                                <div className="w-2 h-6 bg-gradient-to-b from-orange-500 to-amber-500 rounded-full"></div>
                                {t("Astrological Details")}
                            </h2>
                            <div className="p-2 overflow-x-auto">
                                <table className="w-full text-center border-collapse table-fixed min-w-[400px]">
                                    <thead>
                                        <tr className="border-b border-gray-100 bg-orange-50/30">
                                            <th className="px-4 py-3 text-[14px] font-bold text-gray-800 w-[38%] truncate">{userdata?.p1_name}</th>
                                            <th className="px-4 py-3 text-[14px] font-bold text-orange-500 w-[24%] truncate">{t("Parameter")}</th>
                                            <th className="px-4 py-3 text-[14px] font-bold text-gray-800 w-[38%] truncate">{userdata?.p2_name}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {[
                                            { p1: userdata?.data1?.p1?.varna, title: "Varna", p2: userdata?.data1?.p2?.varna },
                                            { p1: userdata?.data1?.p1?.vashya, title: "Vashya", p2: userdata?.data1?.p2?.vashya },
                                            { p1: userdata?.data1?.p1?.yoni, title: "Yoni", p2: userdata?.data1?.p2?.yoni },
                                            { p1: userdata?.data1?.p1?.gana, title: "Gana", p2: userdata?.data1?.p2?.gana },
                                            { p1: userdata?.data1?.p1?.nadi, title: "Nadi", p2: userdata?.data1?.p2?.nadi },
                                            { p1: userdata?.data1?.p1?.sunsign, title: "Sign", p2: userdata?.data1?.p2?.sunsign },
                                            { p1: userdata?.data1?.p1?.sunsign, title: "Sign Lord", p2: userdata?.data1?.p2?.sunsign },
                                            { p1: userdata?.data1?.p1?.nakshatra, title: "Nakshatra", p2: userdata?.data1?.p2?.nakshatra },
                                            { p1: userdata?.data1?.p1?.prahar, title: "Charan", p2: userdata?.data1?.p2?.prahar },
                                            { p1: userdata?.data1?.p1?.tatva, title: "Tatva", p2: userdata?.data1?.p2?.tatva },
                                            { p1: userdata?.data1?.p1?.rashi_akshar, title: "Name Alphabet", p2: userdata?.data1?.p2?.rashi_akshar },
                                            { p1: userdata?.data1?.p1?.paya?.type, title: "Paya", p2: userdata?.data1?.p2?.paya?.type }
                                        ].map((item, idx) => (
                                            <tr key={idx} className="border-b border-gray-50 last:border-b-0 hover:bg-orange-50/20 transition-colors">
                                                <td className="px-4 py-3 text-[14px] text-gray-600 truncate">{renderVal(item.p1)}</td>
                                                <td className="px-4 py-3 font-semibold text-[13px] text-gray-700 bg-orange-50/10 border-x border-gray-50 whitespace-nowrap">{t(item.title)}</td>
                                                <td className="px-4 py-3 text-[14px] text-gray-600 truncate">{renderVal(item.p2)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                    </div>}

                    {detailsstep === 3 && <div className="w-full flex flex-col xl:flex-row gap-6 my-4 animate_fade_in_card">
                        
                        {[
                            { name: userdata?.p1_name, planets: userdata?.data1?.p1?.planets || [] },
                            { name: userdata?.p2_name, planets: userdata?.data1?.p2?.planets || [] }
                        ].map((person, idx) => (
                            <div key={idx} className="flex-1 border border-orange-100/50 rounded-2xl bg-white shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden">
                                <h2 className="px-5 py-4 font-bold text-[18px] text-gray-900 border-b border-gray-100 flex items-center gap-2">
                                    <div className="w-2 h-6 bg-gradient-to-b from-orange-500 to-amber-500 rounded-full"></div>
                                    {person.name} {t("Planetary Position")}
                                </h2>
                                <div className="p-4 overflow-x-auto">
                                    <table className="w-full text-left border-collapse min-w-[500px]">
                                        <thead>
                                            <tr className="border-b border-gray-200">
                                                <th className="px-4 py-3 text-[14px] font-bold text-gray-800">{t("Planets")}</th>
                                                <th className="px-4 py-3 text-[14px] font-bold text-gray-800">{t("Sign")}</th>
                                                <th className="px-4 py-3 text-[14px] font-bold text-gray-800">{t("Degrees")}</th>
                                                <th className="px-4 py-3 text-[14px] font-bold text-gray-800">{t("Sign Lord")}</th>
                                                <th className="px-4 py-3 text-[14px] font-bold text-gray-800">{t("Nakshatra")}</th>
                                                <th className="px-4 py-3 text-[14px] font-bold text-gray-800">{t("Nakshatra Lord")}</th>
                                                <th className="px-4 py-3 text-[14px] font-bold text-gray-800 text-center">{t("House")}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {person.planets.map((planet, pIdx) => (
                                                <tr key={pIdx} className="border-b border-gray-50 last:border-b-0 hover:bg-orange-50/20 transition-colors">
                                                    <td className="px-4 py-3 font-semibold text-[14px] text-gray-700 whitespace-nowrap">{planet.name}</td>
                                                    <td className="px-4 py-3 text-[14px] text-gray-600">{planet.sign}</td>
                                                    <td className="px-4 py-3 text-[14px] text-gray-600">{planet.full_degree}</td>
                                                    <td className="px-4 py-3 text-[14px] text-gray-600">{planet.rashi_lord}</td>
                                                    <td className="px-4 py-3 text-[14px] text-gray-600">{planet.nakshatra}</td>
                                                    <td className="px-4 py-3 text-[14px] text-gray-600">{planet.nakshatra_lord}</td>
                                                    <td className="px-4 py-3 text-[14px] text-gray-600 text-center">{planet.house}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        ))}

                    </div>}

                    {detailsstep === 4 && <div className="w-full flex flex-col gap-8 my-4 animate_fade_in_card">
                        
                        {[
                            { title: "Lagna Chart (Birth Chart)", key: "data1" },
                            { title: "Chalit Chart", key: "data2" },
                            { title: "Moon Chart", key: "data3" },
                            { title: "Navmansha Chart (D9)", key: "data4" }
                        ].map((item, idx) => (
                            <div key={idx} className="border border-orange-100/50 rounded-2xl bg-white shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden p-6">
                                <h2 className="font-bold text-[18px] text-gray-900 border-b border-gray-100 pb-4 mb-6 flex items-center gap-2">
                                    <div className="w-2 h-6 bg-gradient-to-b from-orange-500 to-amber-500 rounded-full"></div>
                                    {t(item.title)}
                                </h2>
                                <div className="flex flex-col md:flex-row items-center justify-around gap-6">
                                    
                                    <div className="flex-1 flex flex-col items-center max-w-[360px] w-full">
                                        <span className="text-sm text-gray-500 font-semibold bg-orange-50 px-4 py-1.5 rounded-full border border-orange-100/50 mb-3 truncate max-w-[280px]">
                                            {userdata?.p1_name}
                                        </span>
                                        <div className="w-full aspect-square rounded-xl overflow-hidden border border-orange-50 bg-orange-50/10 p-2 flex items-center justify-center hover:scale-[1.02] transition-transform duration-300 shadow-sm">
                                            <ImageLoad url={userdata?.[item.key]?.p1?.base64_image} CustomeStyle={"w-full h-full object-contain"} alt="img" />
                                        </div>
                                    </div>

                                    <div className="hidden md:flex items-center justify-center">
                                        <div className="h-16 w-px bg-gray-100"></div>
                                    </div>

                                    <div className="flex-1 flex flex-col items-center max-w-[360px] w-full">
                                        <span className="text-sm text-gray-500 font-semibold bg-orange-50 px-4 py-1.5 rounded-full border border-orange-100/50 mb-3 truncate max-w-[280px]">
                                            {userdata?.p2_name}
                                        </span>
                                        <div className="w-full aspect-square rounded-xl overflow-hidden border border-orange-50 bg-orange-50/10 p-2 flex items-center justify-center hover:scale-[1.02] transition-transform duration-300 shadow-sm">
                                            <ImageLoad url={userdata?.[item.key]?.p2?.base64_image} CustomeStyle={"w-full h-full object-contain"} alt="img" />
                                        </div>
                                    </div>

                                </div>
                            </div>
                        ))}

                    </div>}

                    {detailsstep === 5 && <div className="w-full max-w-3xl mx-auto my-4 animate_fade_in_card">
                        <div className="border border-orange-100/50 rounded-2xl bg-white shadow-sm overflow-hidden p-6">
                            <h2 className="font-bold text-[18px] text-gray-900 border-b border-gray-100 pb-4 mb-6 flex items-center gap-2">
                                <div className="w-2 h-6 bg-gradient-to-b from-orange-500 to-amber-500 rounded-full"></div>
                                {userdata?.p1_name} - {t("Vimshottari Dasha")}
                            </h2>
                            <div className="space-y-4">
                                {Object.entries(userdata?.data1?.p1?.maha_dasha || {}).map(([name, data], index) => (
                                    <Vimshottari_Dasha key={index} name={name} data={data} />
                                ))}
                            </div>
                        </div>
                    </div>}

                    {detailsstep === 6 && <div className="w-full max-w-3xl mx-auto my-4 animate_fade_in_card">
                        <div className="border border-orange-100/50 rounded-2xl bg-white shadow-sm overflow-hidden p-6">
                            <h2 className="font-bold text-[18px] text-gray-900 border-b border-gray-100 pb-4 mb-6 flex items-center gap-2">
                                <div className="w-2 h-6 bg-gradient-to-b from-orange-500 to-amber-500 rounded-full"></div>
                                {userdata?.p2_name} - {t("Vimshottari Dasha")}
                            </h2>
                            <div className="space-y-4">
                                {Object.entries(userdata?.data1?.p2?.maha_dasha || {}).map(([name, data], index) => (
                                    <Vimshottari_Dasha key={index} name={name} data={data} />
                                ))}
                            </div>
                        </div>
                    </div>}

                    {detailsstep === 7 && <div className="w-full max-w-3xl mx-auto my-4 animate_fade_in_card space-y-6">
                        
                        <div className="border border-orange-100/50 rounded-2xl bg-white shadow-sm p-6 hover:shadow-md transition-all duration-300">
                            <h2 className="font-bold text-[18px] text-gray-900 border-b border-gray-100 pb-4 mb-4 flex items-center gap-2">
                                <div className="w-2 h-6 bg-gradient-to-b from-orange-500 to-amber-500 rounded-full"></div>
                                {t("Manglik Analysis Recommendation")}
                            </h2>
                            <p className="text-gray-600 leading-relaxed text-[15px]">{userdata?.data1?.content}</p>
                        </div>

                        <div className="flex flex-col sm:flex-row gap-4 items-stretch justify-center">
                            {[
                                { name: userdata?.p1_name, hasManglik: true },
                                { name: userdata?.p2_name, hasManglik: true }
                            ].map((profile, idx) => (
                                <div key={idx} className="flex-1 border border-orange-100/50 rounded-2xl bg-white shadow-sm p-5 hover:shadow-md transition-all duration-300 flex items-center justify-between gap-4">
                                    <div className="flex items-center gap-3">
                                        <div className="w-10 h-10 rounded-full bg-orange-50 border border-orange-100 flex items-center justify-center text-orange-500 font-bold text-sm">
                                            {idx === 0 ? "P1" : "P2"}
                                        </div>
                                        <h3 className="font-bold text-gray-800 text-[15px] truncate max-w-[150px]">{profile.name}</h3>
                                    </div>
                                    <span className="px-4 py-1.5 rounded-full font-bold text-xs bg-red-50 text-red-500 border border-red-100/50 whitespace-nowrap">
                                        {t("Manglik")}
                                    </span>
                                </div>
                            ))}
                        </div>

                    </div>}

                    {detailsstep === 8 && <div className="w-full max-w-4xl mx-auto my-4 animate_fade_in_card space-y-6">
                        
                        <div className="border border-orange-100/50 rounded-2xl bg-white shadow-sm p-6 hover:shadow-md transition-all duration-300">
                            <h2 className="font-bold text-[18px] text-gray-900 border-b border-gray-100 pb-4 mb-4 flex items-center gap-2">
                                <div className="w-2 h-6 bg-gradient-to-b from-orange-500 to-amber-500 rounded-full"></div>
                                {t("What is AshtaKoot ??")}
                            </h2>
                            <p className="text-gray-600 leading-relaxed text-[15px]">{userdata?.data1?.ashtakoot_milan_result?.content}</p>
                        </div>

                        <div className="border border-orange-100/50 rounded-2xl bg-white shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden">
                            <h2 className="px-5 py-4 font-bold text-[18px] text-gray-900 border-b border-gray-100 flex items-center gap-2 bg-orange-50/20">
                                <div className="w-2 h-6 bg-gradient-to-b from-orange-500 to-amber-500 rounded-full"></div>
                                {t("AshtaKoot Milan Report")}
                            </h2>
                            <div className="p-4 overflow-x-auto">
                                <table className="w-full text-left border-collapse min-w-[650px]">
                                    <thead>
                                        <tr className="border-b border-gray-200">
                                            <th className="px-4 py-3 text-[14px] font-bold text-gray-800">{t("Attributes")}</th>
                                            <th className="px-4 py-3 text-[14px] font-bold text-gray-800">{t("Description")}</th>
                                            <th className="px-4 py-3 text-[14px] font-bold text-gray-800">{userdata?.p1_name}</th>
                                            <th className="px-4 py-3 text-[14px] font-bold text-gray-800">{userdata?.p2_name}</th>
                                            <th className="px-4 py-3 text-[14px] font-bold text-gray-800 text-center">{t("Total")}</th>
                                            <th className="px-4 py-3 text-[14px] font-bold text-gray-800 text-center">{t("Received")}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Object.entries(userdata?.data1?.ashtakoot_milan || {}).map(([name, data], idx) => (
                                            <tr key={idx} className="border-b border-gray-50 last:border-b-0 hover:bg-orange-50/20 transition-colors">
                                                <td className="px-4 py-3 font-semibold text-[14px] text-gray-700 whitespace-nowrap">
                                                    {t(handlecCapitalizeWords(name.replaceAll("_", " ")).replaceAll(",", " "))}
                                                </td>
                                                <td className="px-4 py-3 text-[14px] text-gray-600">{data.area_of_life}</td>
                                                <td className="px-4 py-3 text-[14px] text-gray-600">{data.p1}</td>
                                                <td className="px-4 py-3 text-[14px] text-gray-600">{data.p2}</td>
                                                <td className="px-4 py-3 text-[14px] text-gray-600 text-center">{data.max_ponits}</td>
                                                <td className="px-4 py-3 text-[14px] text-gray-600 text-center font-semibold text-orange-600">
                                                    {Number(data.points_obtained || 0).toFixed(1)}
                                                </td>
                                            </tr>
                                        ))}
                                        <tr className="bg-orange-50/50 font-bold border-t border-orange-100">
                                            <td className="px-4 py-3 text-[14px] text-gray-900" colSpan="4">{t("Total")}</td>
                                            <td className="px-4 py-3 text-[14px] text-gray-900 text-center">{userdata?.data1?.ashtakoot_milan_result?.max_ponits}</td>
                                            <td className="px-4 py-3 text-[14px] text-orange-600 text-center text-lg font-bold">
                                                {userdata?.data1?.ashtakoot_milan_result?.points_obtained}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                    </div>}

                    {detailsstep === 9 && <div className="w-full max-w-3xl mx-auto my-4 animate_fade_in_card space-y-6">
                        
                        <div className="border border-orange-100/50 rounded-2xl bg-white shadow-sm p-6 hover:shadow-md transition-all duration-300">
                            <h2 className="font-bold text-[18px] text-gray-900 border-b border-gray-100 pb-4 mb-4 flex items-center gap-2">
                                <div className="w-2 h-6 bg-gradient-to-b from-orange-500 to-amber-500 rounded-full"></div>
                                {t("What is BhaKoot Dosha ??")}
                            </h2>
                            <p className="text-gray-600 leading-relaxed text-[15px]">{userdata?.data1?.ashtakoot_milan_result?.content}</p>
                        </div>

                        <div className="flex flex-col sm:flex-row gap-4 items-stretch justify-center">
                            <div className="flex-1 border border-orange-100/50 rounded-2xl bg-white shadow-sm p-5 hover:shadow-md transition-all duration-300 flex items-center justify-between">
                                <span className="font-bold text-gray-800 text-[15px]">{userdata?.p1_name}</span>
                                <span className="px-4 py-1.5 rounded-full font-semibold text-xs bg-orange-50 text-orange-600 border border-orange-100/50">
                                    {t("Gemini")}
                                </span>
                            </div>
                            <div className="flex-1 border border-orange-100/50 rounded-2xl bg-white shadow-sm p-5 hover:shadow-md transition-all duration-300 flex items-center justify-between">
                                <span className="font-bold text-gray-800 text-[15px]">{userdata?.p2_name}</span>
                                <span className="px-4 py-1.5 rounded-full font-semibold text-xs bg-orange-50 text-orange-600 border border-orange-100/50">
                                    {t("Gemini")}
                                </span>
                            </div>
                        </div>
                    </div>}

                    {detailsstep === 10 && <div className="w-full max-w-3xl mx-auto my-4 animate_fade_in_card space-y-6">
                        
                        <div className="border border-orange-100/50 rounded-2xl bg-white shadow-sm p-6 hover:shadow-md transition-all duration-300">
                            <h2 className="font-bold text-[18px] text-gray-900 border-b border-gray-100 pb-4 mb-4 flex items-center gap-2">
                                <div className="w-2 h-6 bg-gradient-to-b from-orange-500 to-amber-500 rounded-full"></div>
                                {t("What is Nadi Dosha ??")}
                            </h2>
                            <p className="text-gray-600 leading-relaxed text-[15px]">{userdata?.data1?.ashtakoot_milan_result?.content}</p>
                        </div>

                        <div className="flex flex-col sm:flex-row gap-4 items-stretch justify-center">
                            <div className="flex-1 border border-orange-100/50 rounded-2xl bg-white shadow-sm p-5 hover:shadow-md transition-all duration-300 flex items-center justify-between">
                                <span className="font-bold text-gray-800 text-[15px]">{userdata?.p1_name}</span>
                                <span className="px-4 py-1.5 rounded-full font-semibold text-xs bg-orange-50 text-orange-600 border border-orange-100/50">
                                    {t("Madhya")}
                                </span>
                            </div>
                            <div className="flex-1 border border-orange-100/50 rounded-2xl bg-white shadow-sm p-5 hover:shadow-md transition-all duration-300 flex items-center justify-between">
                                <span className="font-bold text-gray-800 text-[15px]">{userdata?.p2_name}</span>
                                <span className="px-4 py-1.5 rounded-full font-semibold text-xs bg-orange-50 text-orange-600 border border-orange-100/50">
                                    {t("Madhya")}
                                </span>
                            </div>
                        </div>

                        <div className="border border-red-100 rounded-2xl bg-red-50/30 p-5 flex items-center gap-4 text-red-700 shadow-sm">
                            <div className="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center text-red-500 flex-shrink-0">
                                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                                </svg>
                            </div>
                            <div>
                                <h4 className="font-bold text-[16px] mb-1">{t("Nadi Dosha Alert")}</h4>
                                <p className="text-[14px] text-red-600/90">{t("Nadi dosha is present")}</p>
                            </div>
                        </div>

                    </div>}

                    {detailsstep === 11 && <div className="w-full max-w-5xl mx-auto my-4 animate_fade_in_card">
                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                            {Object.entries(userdata?.data1?.ashtakoot_milan || {}).map(([name, data], index) => {
                                const isMatch = data.points_obtained > 0;
                                return (
                                    <div key={index} className="border border-orange-100/50 rounded-2xl bg-white shadow-sm hover:shadow-md transition-all duration-300 p-5 flex flex-col items-center text-center hover:-translate-y-1">
                                        <div className={`w-14 h-14 rounded-full flex items-center justify-center p-3 mb-4 ${isMatch ? "bg-green-50 border border-green-100" : "bg-red-50 border border-red-100"}`}>
                                            <img src={isMatch ? ThumbUp : ThumbDown} className="w-full h-full object-contain" alt="Thumb" />
                                        </div>
                                        <h3 className="font-bold text-gray-800 text-[16px] mb-1 truncate w-full" title={data.area_of_life}>
                                            {data.area_of_life}
                                        </h3>
                                        <span className="text-[12px] text-gray-400 font-semibold uppercase tracking-wider mb-2">
                                            {t(name.replaceAll("_", " "))}
                                        </span>
                                        <div className="text-[14px] text-gray-600 font-medium">
                                            <span className={isMatch ? "text-green-600 font-bold" : "text-red-500 font-bold"}>
                                                {Number(data.points_obtained || 0).toFixed(1)}
                                            </span>
                                            {" / "}
                                            <span className="text-gray-500">{data.max_ponits}</span>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>}

                    {detailsstep === 12 && <div className="w-full max-w-4xl mx-auto my-4 animate_fade_in_card space-y-6">
                        
                        <div className="border border-orange-100/50 rounded-2xl bg-white shadow-sm p-6 hover:shadow-md transition-all duration-300">
                            <h2 className="font-bold text-[18px] text-gray-900 border-b border-gray-100 pb-4 mb-4 flex items-center gap-2">
                                <div className="w-2 h-6 bg-gradient-to-b from-orange-500 to-amber-500 rounded-full"></div>
                                {t("What is Nadi Dosha ??")}
                            </h2>
                            <p className="text-gray-600 leading-relaxed text-[15px]">{userdata?.data1?.dashakoot_milan_result?.content}</p>
                        </div>

                        <div className="border border-orange-100/50 rounded-2xl bg-white shadow-sm p-6 hover:shadow-md transition-all duration-300">
                            <h2 className="font-bold text-[18px] text-gray-900 border-b border-gray-100 pb-4 mb-4 flex items-center gap-2">
                                <div className="w-2 h-6 bg-gradient-to-b from-orange-500 to-amber-500 rounded-full"></div>
                                {t("The")} {Object.entries(userdata?.data1?.dashakoot_milan || {}).length} {t("porutham considered for horoscope matching are as follows :")}
                            </h2>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
                                {Object.entries(userdata?.data1?.dashakoot_milan || {}).map(([name, data], index) => (
                                    <div key={index} className="flex gap-3 items-start border-b border-gray-50 pb-3 last:border-0 md:[&:nth-last-child(-n+2)]:border-0">
                                        <div className="w-7 h-7 rounded-full bg-orange-50 border border-orange-100 text-orange-600 font-bold text-xs flex items-center justify-center flex-shrink-0 mt-0.5">
                                            {index + 1}
                                        </div>
                                        <div>
                                            <h4 className="font-bold text-[15px] text-gray-800 mb-0.5">{t(handlecCapitalizeWords(name))}</h4>
                                            <p className="text-[13px] text-gray-500 leading-normal">{data?.area_of_life}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="border border-orange-100/50 rounded-2xl bg-white shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden">
                            <h2 className="px-5 py-4 font-bold text-[18px] text-gray-900 border-b border-gray-100 flex items-center gap-2 bg-orange-50/20">
                                <div className="w-2 h-6 bg-gradient-to-b from-orange-500 to-amber-500 rounded-full"></div>
                                {t("Dashakoot Milan Table")}
                            </h2>
                            <div className="p-4 overflow-x-auto">
                                <table className="w-full text-left border-collapse min-w-[550px]">
                                    <thead>
                                        <tr className="border-b border-gray-200">
                                            <th className="px-4 py-3 text-[14px] font-bold text-gray-800">{t("Attributes")}</th>
                                            <th className="px-4 py-3 text-[14px] font-bold text-gray-800">{userdata?.p1_name}</th>
                                            <th className="px-4 py-3 text-[14px] font-bold text-gray-800">{userdata?.p2_name}</th>
                                            <th className="px-4 py-3 text-[14px] font-bold text-gray-800 text-center">{t("Total")}</th>
                                            <th className="px-4 py-3 text-[14px] font-bold text-gray-800 text-center">{t("Received")}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Object.entries(userdata?.data1?.dashakoot_milan || {}).map(([name, data], index) => (
                                            <tr key={index} className="border-b border-gray-50 last:border-b-0 hover:bg-orange-50/20 transition-colors">
                                                <td className="px-4 py-3 font-semibold text-[14px] text-gray-700">
                                                    {t(handlecCapitalizeWords(name.replaceAll("_", " ")).replaceAll(",", " "))}
                                                </td>
                                                <td className="px-4 py-3 text-[14px] text-gray-600">{data.p1}</td>
                                                <td className="px-4 py-3 text-[14px] text-gray-600">{data.p2}</td>
                                                <td className="px-4 py-3 text-[14px] text-gray-600 text-center">{data.max_ponits}</td>
                                                <td className="px-4 py-3 text-[14px] text-gray-600 text-center font-semibold text-orange-600">
                                                    {Number(data.points_obtained || 0).toFixed(1)}
                                                </td>
                                            </tr>
                                        ))}
                                        <tr className="bg-orange-50/50 font-bold border-t border-orange-100">
                                            <td className="px-4 py-3 text-[14px] text-gray-900" colSpan="3">{t("Total")}</td>
                                            <td className="px-4 py-3 text-[14px] text-gray-900 text-center">{userdata?.data1?.dashakoot_milan_result?.max_ponits}</td>
                                            <td className="px-4 py-3 text-[14px] text-orange-600 text-center text-lg font-bold">
                                                {userdata?.data1?.dashakoot_milan_result?.points_obtained}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                    </div>}

                    {detailsstep === 13 && <div className="w-full flex flex-col lg:flex-row gap-8 my-4 animate_fade_in_card">
                        
                        {[
                            { name: userdata?.p1_name, img: userdata?.data1?.p1?.image, article: userdata?.data1?.p1?.article },
                            { name: userdata?.p2_name, img: userdata?.data1?.p2?.image, article: userdata?.data1?.p2?.article }
                        ].map((person, idx) => (
                            <div key={idx} className="flex-1 border border-orange-100/50 rounded-2xl bg-white shadow-sm hover:shadow-md transition-all duration-300 p-6 flex flex-col items-center">
                                <h2 className="font-bold text-[18px] text-gray-900 border-b border-orange-100 pb-4 mb-4 text-center w-full">
                                    {person.name} {t("Personality Report")}
                                </h2>
                                {person.img && (
                                    <div className="w-48 h-48 rounded-full overflow-hidden border-4 border-orange-50 shadow-sm p-1.5 my-4 hover:scale-105 transition-transform duration-300">
                                        <ImageLoad url={person.img} CustomeStyle={"w-full h-full rounded-full object-cover"} alt={"Zodiac img"} />
                                    </div>
                                )}
                                <div className="text-gray-600 leading-relaxed text-[15px] space-y-4 mt-4 text-justify w-full">
                                    {(person.article?.split("\n\n") || []).map((line, pIdx) => (
                                        <p key={pIdx}>{line}</p>
                                    ))}
                                </div>
                            </div>
                        ))}

                    </div>}

                    {detailsstep === 14 && <div className="w-full max-w-4xl mx-auto my-4 animate_fade_in_card">
                        
                        <div className="border border-orange-100/50 rounded-2xl bg-white shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden">
                            <h2 className="px-5 py-4 font-bold text-[18px] text-gray-900 border-b border-gray-100 flex items-center gap-2 bg-orange-50/20">
                                <div className="w-2 h-6 bg-gradient-to-b from-orange-500 to-amber-500 rounded-full"></div>
                                {t("Match Making Report")}
                            </h2>
                            <div className="p-4 overflow-x-auto">
                                <table className="w-full text-left border-collapse min-w-[650px]">
                                    <thead>
                                        <tr className="border-b border-gray-200">
                                            <th className="px-4 py-3 text-[14px] font-bold text-gray-800">{t("Attributes")}</th>
                                            <th className="px-4 py-3 text-[14px] font-bold text-gray-800">{t("Description")}</th>
                                            <th className="px-4 py-3 text-[14px] font-bold text-gray-800">{userdata?.p1_name}</th>
                                            <th className="px-4 py-3 text-[14px] font-bold text-gray-800">{userdata?.p2_name}</th>
                                            <th className="px-4 py-3 text-[14px] font-bold text-gray-800 text-center">{t("Total")}</th>
                                            <th className="px-4 py-3 text-[14px] font-bold text-gray-800 text-center">{t("Received")}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Object.entries(userdata?.data1?.ashtakoot_milan || {}).map(([name, data], idx) => (
                                            <tr key={idx} className="border-b border-gray-50 last:border-b-0 hover:bg-orange-50/20 transition-colors">
                                                <td className="px-4 py-3 font-semibold text-[14px] text-gray-700 whitespace-nowrap">
                                                    {t(handlecCapitalizeWords(name.replaceAll("_", " ")).replaceAll(",", " "))}
                                                </td>
                                                <td className="px-4 py-3 text-[14px] text-gray-600">{data.area_of_life}</td>
                                                <td className="px-4 py-3 text-[14px] text-gray-600">{data.p1}</td>
                                                <td className="px-4 py-3 text-[14px] text-gray-600">{data.p2}</td>
                                                <td className="px-4 py-3 text-[14px] text-gray-600 text-center">{data.max_ponits}</td>
                                                <td className="px-4 py-3 text-[14px] text-gray-600 text-center font-semibold text-orange-600">
                                                    {Number(data.points_obtained || 0).toFixed(1)}
                                                </td>
                                            </tr>
                                        ))}
                                        <tr className="bg-orange-50/50 font-bold border-t border-orange-100">
                                            <td className="px-4 py-3 text-[14px] text-gray-900" colSpan="4">{t("Total")}</td>
                                            <td className="px-4 py-3 text-[14px] text-gray-900 text-center">{userdata?.data1?.ashtakoot_milan_result?.max_ponits}</td>
                                            <td className="px-4 py-3 text-[14px] text-orange-600 text-center text-lg font-bold">
                                                {userdata?.data1?.ashtakoot_milan_result?.points_obtained}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                    </div>}

                    {detailsstep === 15 && <div><NavPanchamYoga userdata={userdata} /></div>}

                </div>

            </div>}

            {
                showlist && (
                    <div onClick={() => setShowList(false)} className="model flex items-center justify-center bg-black/40 backdrop-blur-sm fixed inset-0 z-50 transition-opacity">
                        <div 
                            onClick={(e) => e.stopPropagation()} 
                            className="w-[360px] max-h-[70vh] bg-white rounded-2xl shadow-xl flex flex-col overflow-hidden border border-orange-50"
                        >
                            <div className="px-5 py-4 border-b border-gray-100 flex items-center justify-between bg-orange-50/10">
                                <h3 className="font-bold text-gray-800 text-[16px]">{t("Select Category")}</h3>
                                <button onClick={() => setShowList(false)} className="text-gray-400 hover:text-gray-600 transition-colors">
                                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                </button>
                            </div>
                            <div className="flex-1 overflow-y-auto p-4 space-y-2 max-h-[50vh] scroll_container">
                                {kundliTypeList.map((item, index) => {
                                    const IsSelected = isstep === index;
                                    return (
                                        <div 
                                            onClick={() => handleTypeOfdetail(index, item)} 
                                            key={index} 
                                            className={`px-4 h-[44px] flex items-center justify-between rounded-xl cursor-pointer transition-all duration-300 ${IsSelected ? "bg-gradient-to-r from-orange-500 to-amber-500 text-white font-bold shadow-sm" : "border border-gray-150 hover:bg-orange-50/20 text-gray-700"}`}
                                        >
                                            <span className="text-[14px]">{t(item)}</span>
                                            {apiloading === item ? (
                                                <Btn_loader CustomeStyle={IsSelected ? "bg-white" : "bg-[--bgcolor]"} />
                                            ) : IsSelected ? (
                                                <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7" />
                                                </svg>
                                            ) : null}
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                )
            }

            <PageLoading loading={loading} />

        </div >
    )
}

export default Kundali_Matching_details

const Vimshottari_Dasha = ({ name, data }) => {

    const { t } = useTranslation();
    const [isshow, setIsShow] = useState(false);

    return (
        <div className="border border-orange-100/50 rounded-2xl bg-white shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden">
            <div 
                onClick={() => setIsShow(!isshow)} 
                className="flex items-center justify-between gap-4 cursor-pointer px-5 py-4 bg-orange-50/20 hover:bg-orange-50/50 transition-colors select-none"
            >
                <h3 className="font-bold text-[15px] text-gray-800 flex items-center gap-2">
                    <span className="w-2.5 h-2.5 rounded-full bg-gradient-to-r from-orange-500 to-amber-500 flex-shrink-0"></span>
                    {t(name)} {t("Mahadasha")}
                </h3>
                <div className="flex items-center gap-3 text-xs text-gray-500 font-medium">
                    <span>({data?.start_date} - {data?.end_date})</span>
                    <svg width="20" height="20" className={`duration-300 transform ${isshow ? "rotate-[180deg] text-orange-500" : "rotate-0 text-gray-400"}`} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 15C11.744 15 11.488 14.9021 11.293 14.7071L7.29301 10.7071C6.90201 10.3161 6.90201 9.68401 7.29301 9.29301C7.68401 8.90201 8.31607 8.90201 8.70707 9.29301L12 12.586L15.293 9.29301C15.684 8.90201 16.3161 8.90201 16.7071 9.29301C17.0981 9.68401 17.0981 10.3161 16.7071 10.7071L12.7071 14.7071C12.5121 14.9021 12.256 15 12 15Z" fill="currentColor" />
                    </svg>
                </div>
            </div>
            <AnimatePresence initial={false}>
                {isshow && (
                    <motion.div
                        key="content"
                        initial="collapsed"
                        animate="open"
                        exit="collapsed"
                        variants={{
                            open: { height: "auto", opacity: 1 },
                            collapsed: { height: 0, opacity: 0 }
                        }}
                        transition={{ duration: 0.3, ease: "easeInOut" }}
                        className="overflow-hidden bg-white border-t border-orange-50"
                    >
                        <div className="p-4 space-y-3 pl-8 relative">
                            <div className="absolute left-6 top-6 bottom-6 w-0.5 bg-orange-100"></div>

                            {Object.entries(data.antar_dasha || {}).map(([name2, data2], index) => (
                                <div key={index} className="relative flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1 group pb-2 last:pb-0">
                                    <div className="absolute left-[-11px] top-[7px] w-2.5 h-2.5 rounded-full border-2 border-orange-400 bg-white group-hover:bg-orange-500 transition-colors duration-300"></div>

                                    <h4 className="font-semibold text-[14px] text-gray-700 pl-3 group-hover:text-orange-600 transition-colors duration-300">{t(name2)}</h4>
                                    <p className="text-[13px] text-gray-500 pl-3 sm:pl-0 font-medium">
                                        {t("Start")}: <span className="text-gray-700 font-semibold">{data2?.start_time}</span> | {t("End")}: <span className="text-gray-700 font-semibold">{data2?.end_time}</span>
                                    </p>
                                </div>
                            ))}
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
}

const NavPanchamYoga = ({ userdata }) => {

    const { t } = useTranslation();
    const navData = userdata?.data1?.nav_pancham_yoga || {};
    const planets = Object.keys(navData);

    return (
        <div className="border border-orange-100/50 rounded-2xl bg-white shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden w-full max-w-4xl mx-auto my-4">
            <h2 className="px-5 py-4 font-bold text-[18px] text-gray-900 border-b border-gray-100 flex items-center gap-2 bg-orange-50/20">
                <div className="w-2 h-6 bg-gradient-to-b from-orange-500 to-amber-500 rounded-full"></div>
                {t("Nav Pancham Yoga Matrix")}
            </h2>
            <div className="p-4 overflow-x-auto">
                <table className="w-full text-center border-collapse min-w-[750px]">
                    <thead>
                        <tr className="border-b border-gray-200 bg-orange-50/10">
                            <th className="px-4 py-3 text-[14px] font-bold text-orange-600 border border-orange-50">
                                {t("P1 / P2")}
                            </th>
                            {planets.map((col) => (
                                <th key={col} className="px-3 py-3 text-[13px] font-bold text-gray-800 border border-orange-50">
                                    {t(col)}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {planets.map((row) => (
                            <tr key={row} className="hover:bg-orange-50/20 transition-colors">
                                <td className="px-4 py-3 font-semibold text-[14px] text-gray-800 border border-orange-50 bg-orange-50/5 text-left">
                                    {t(row)}
                                </td>
                                {planets.map((col) => {
                                    const cellValue = navData[row]?.[col] || "-";
                                    return (
                                        <td key={col} className="px-3 py-3 text-[13px] text-gray-600 border border-orange-50">
                                            {cellValue}
                                        </td>
                                    );
                                })}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}